import axios, {HttpStatusCode} from "axios";

const axiosInstance = axios.create({
    withCredentials: false,
});

const errorCodes = [
    HttpStatusCode.BadGateway,
    HttpStatusCode.Forbidden,
    HttpStatusCode.NotFound,
    HttpStatusCode.Unauthorized,
    HttpStatusCode.InternalServerError,
    HttpStatusCode.TooManyRequests,
];

axiosInstance.interceptors.response.use(
    config => {
        const data = config.data;

        if ((data?.success === false && errorCodes.includes(data.status))) {
            config.status = data.status;
            return Promise.reject(config);
        }

        return config;
    },
    failedRequest => Promise.reject(failedRequest),
);

export default axiosInstance;